// Placeholder Navbar component for POS system
const Navbar = ({ onMenuClick }) => {
  return (
    <nav style={{ padding: '1rem', background: '#f3f4f6', borderBottom: '1px solid #e5e7eb' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600' }}>POS System</h2>
      </div>
    </nav>
  );
};

export default Navbar;

